import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const dashboardIcon = createIconDefinition(
  'dashboard',
  `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 2.5H9.16667V10.8333H2.5V2.5ZM17.5 2.5H10.8333V7.5H17.5V2.5ZM7.5 9.16667V4.16667H4.16667V9.16667H7.5ZM15.8333 5.83333V4.16667H12.5V5.83333H15.8333ZM15.8333 10.8333V15.8333H12.5V10.8333H15.8333ZM7.5 15.8333V14.1667H4.16667V15.8333H7.5ZM17.5 9.16667H10.8333V17.5H17.5V9.16667ZM2.5 12.5H9.16667V17.5H2.5V12.5Z" fill="#5A42D0"/>
</svg>
`,
);
